import styled from "styled-components";
import {Link} from "react-router-dom";
import {InnerLink} from "../../../../styles/business-components";

export const Container = styled.div`
  width: 100%;
  height: 300px;

  @media only screen and (${({theme}) => theme.media.medium}) {
    height: 1000px;
  }
`

export const Banner = styled.div<{imagePath: string, staticImagePath: string}>`
  position: relative;
  width: 100%;
  height: 300px;
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({staticImagePath}) => `url(${staticImagePath}) no-repeat`};
    background-size: contain;
    filter: grayscale(100%);

    @media only screen and (${({theme}) => theme.media.large}) {
      background: ${({imagePath}) => `url(${imagePath}) no-repeat`};
      background-size: cover;
    }
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    height: 800px;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: ${({theme}) => `url('data:image/svg+xml,<svg width="1920" height="114" viewBox="0 0 1920 114" fill="${theme.business.colors.primaryBackground}" xmlns="http://www.w3.org/2000/svg"><path d="M0 114V64.7001C185.9 0.200142 385.3 -33.8999 827.9 52.3001C1270.7 138.5 1723.4 112.3 1919.8 55.3001H1920V114H0Z"/></svg>') no-repeat bottom`};
    }
  }
`

export const Logo = styled.div`
  position: absolute;
  width: 100%;
`

export const Phone = styled.img`
  position: relative;
  z-index: 10;
  object-fit: contain;
  width: 25%;
  height: auto;
  left: 10%;
  top: 30px;

  @media only screen and (${({theme}) => theme.media.small}) {
    top: 70px;
  }
`

export const Text = styled.span`
  position: absolute;
  z-index: 8;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0 40px 40px 0;
  width: fit-content;
  height: fit-content;
  color: ${({theme}) => theme.business.colors.textColor};
  padding: 5px 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  background: ${({theme}) => theme.business.colors.bannerPhoneHintBg};

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 14px;
    padding: 0.5rem 2rem 0.5rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    font-size: 16px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    padding: 0.5rem 2rem 0.5rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 20px;
    padding: 1rem 2rem 1rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
  }
`

export const Text1 = styled(Text)`
  top: 25%;
  left: 26%;

  @media only screen and (${({theme}) => theme.media.small}) {
    top: 25%;
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: 25%;
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: 30%;
    left: 28%;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: 35%;
    left: 28%;
  }
`

export const Text2 = styled(Text)`
  top: calc(27% + 2rem);
  left: 27%;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    top: calc(25% + 2rem);
    left: 26%;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    top: calc(25% + 2.5rem);
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    top: calc(25% + 2.5rem);
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: calc(25% + 3rem);
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: 44%;
    left: 29%;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: calc(35% + 6rem);
    left: 29%;
  }
`

export const Text3 = styled(Text)`
  top: calc(48% + 2rem);
  left: 31%;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    //top: calc(49% + 2rem);
    left: 26%;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    top: calc(25% + 5rem);
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    top: calc(25% + 5rem);
    left: 28%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: calc(25% + 6rem);
    left: 28%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: 58%;
    left: 30%;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: calc(35% + 12rem);
    left: 30%;
  }
`

export const Info = styled.div`
  position: absolute;
  filter: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  top: 42%;
  right: 18%;
  width: 30%;
  height: fit-content;
  z-index: 20;
  background: ${({theme}) => theme.colors.thirdlyBackground};
  backdrop-filter: blur(8px);
  border-radius: 40px;
  padding: 20px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 40px;
  }
`

export const InfoTitle = styled.div`
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  text-align: left;
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 22px;
    line-height: 30px;
  }
`

export const InfoText = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  text-align: left;
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 20px;
    line-height: 27px;
  }
`

export const InfoLink = styled(InnerLink)`
  font-family: ${({theme}) => theme.font.secondaryFont};
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  text-align: left;
  text-transform: uppercase;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 22px;
    line-height: 26px;
  }
`

export const ButtonWrapper = styled.div`
  position: relative;
  top: 70%;
  text-align: center;
  z-index: 10;

  @media only screen and (${({theme}) => theme.media.small}) {
    position: absolute;
    top: 80%;
    right: 18%;
  }
`

export const SocialBlock = styled.div`
  display: none;
  text-align: center;
  margin-top: 5px;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const SocialLink = styled(Link)`
  margin: 0 5px;
  opacity: 0.7;
  
  & svg {
    height: 20px;
    width: 20px;
  }
  
  &:hover {
    opacity: 1;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    margin: 0 5px;

    & svg {
      height: 30px;
      width: 30px;
    }
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    margin: 0 10px;

    & svg {
      height: 40px;
      width: 40px;
    }
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    margin: 0 10px;

    & svg {
      height: 60px;
      width: 60px;
    }
  }
`